<template>
  <svg
    width="24px"
    height="22px"
    viewBox="0 0 24 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="00-Framework" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Framework" transform="translate(-1291.000000, -360.000000)" fill="currentColor">
        <g id="typo" transform="translate(347.000000, 303.000000)">
          <g id="Group-3" transform="translate(-0.000000, -0.000000)">
            <g id="Presets" transform="translate(944.000000, 14.000000)">
              <g id="erwachsene" transform="translate(0.000000, 42.000000)">
                <g id="Person-/-User-/-events-/-24">
                  <path
                    d="M19.5,10.5 L18,10.5 L18,12 L19.5,12 C20.7421266,12.0012403 21.7487597,13.0078734 21.75,14.25 L21.75,17.25 L23.25,17.25 L23.25,14.25 C23.2475204,12.1799601 21.5700399,10.5024796 19.5,10.5 L19.5,10.5 Z M18,3 C19.2426407,3 20.25,4.00735931 20.25,5.25 C20.25,6.49264069 19.2426407,7.5 18,7.5 C16.7573593,7.5 15.75,6.49264069 15.75,5.25 C15.75,4.00735931 16.7573593,3 18,3 L18,3 Z M18,1.5 C15.9289322,1.5 14.25,3.17893219 14.25,5.25 C14.25,7.32106781 15.9289322,9 18,9 C20.0710678,9 21.75,7.32106781 21.75,5.25 C21.75,4.25543816 21.3549118,3.30161099 20.6516504,2.59834957 C19.948389,1.89508815 18.9945618,1.5 18,1.5 L18,1.5 Z M17.25,22.5 L15.75,22.5 L15.75,21 C15.7487597,19.7578734 14.7421266,18.7512403 13.5,18.75 L10.5,18.75 C9.25787341,18.7512403 8.25124027,19.7578734 8.25,21 L8.25,22.5 L6.75,22.5 L6.75,21 C6.75247959,18.9299601 8.42996014,17.2524796 10.5,17.25 L13.5,17.25 C15.5700399,17.2524796 17.2475204,18.9299601 17.25,21 L17.25,22.5 Z M12,9.75 C13.2426407,9.75 14.25,10.7573593 14.25,12 C14.25,13.2426407 13.2426407,14.25 12,14.25 C10.7573593,14.25 9.75,13.2426407 9.75,12 C9.75,10.7573593 10.7573593,9.75 12,9.75 L12,9.75 Z M12,8.25 C9.92893219,8.25 8.25,9.92893219 8.25,12 C8.25,14.0710678 9.92893219,15.75 12,15.75 C14.0710678,15.75 15.75,14.0710678 15.75,12 C15.75,9.92893219 14.0710678,8.25 12,8.25 L12,8.25 Z M6,10.5 L4.5,10.5 C2.42996014,10.5024796 0.752479587,12.1799601 0.75,14.25 L0.75,17.25 L2.25,17.25 L2.25,14.25 C2.25124027,13.0078734 3.25787341,12.0012403 4.5,12 L6,12 L6,10.5 Z M6,3 C7.24264069,3 8.25,4.00735931 8.25,5.25 C8.25,6.49264069 7.24264069,7.5 6,7.5 C4.75735931,7.5 3.75,6.49264069 3.75,5.25 C3.75,4.00735931 4.75735931,3 6,3 L6,3 Z M6,1.5 C3.92893219,1.5 2.25,3.17893219 2.25,5.25 C2.25,7.32106781 3.92893219,9 6,9 C8.07106781,9 9.75,7.32106781 9.75,5.25 C9.75,4.25543816 9.35491185,3.30161099 8.65165043,2.59834957 C7.94838901,1.89508815 6.99456184,1.5 6,1.5 Z"
                    id="Fill"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Users'
};
</script>
